// Generated by scripts/update-seeq-icons.js from src/svg/seeq/seeq-datalab-lock.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcSeeqDatalabLock = {
  prefix: 'fak',
  iconName: 'seeq-datalab-lock' as IconName,
  icon: [
    1095,
    1024,
    [],
    'e911',
    'M1087.1 906.7l-251.6-579.1v-219.2c26.7-3.2 48.5-25.9 48.6-54.2s-21-50.1-48.6-54.2h-419.8c-26.7 4-48.5 26.7-48.5 54.2s21 51 48.5 54.2v95.4c41.3 17.8 78.5 43.7 109.2 75.3v-169.9h202.3v241l245.8 565.4h-301.7v28.3c0 29.1-7.3 55.8-19.4 80.9h363.2c29.1 0 55-14.6 69.6-39.6 14.6-24.3 15.4-52.6 3.2-77.7v0zM484.5 1023.2c44.5 0 80.1-35.6 80.1-80.1v-277.4c0-33.2-20.2-61.5-48.6-73.6v-77.7c0-128.6-105.2-233.8-233.7-233.7s-233.8 105.2-233.8 234.5v77.7c-28.3 12.1-48.5 40.4-48.5 73.6v277.4c0 44.5 35.6 80.1 80.1 80.1h404.4zM156.1 515.2c0-69.6 56.6-126.2 126.2-126.1s126.2 56.6 126.2 126.1v71.2h-252.4v-71.2z',
  ],
} satisfies IconDefinition;
